globalThis.__VUE_OPTIONS_API__ = !0;
globalThis.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = !0;
globalThis.__VUE_PROD_DEVTOOLS__ = !1;
let e = {
  createClient: null,
  clientDict: {}
};
const c = /* @__PURE__ */ new Set(), _ = (t) => (c.add(t), () => c.delete(t)), s = () => e, n = () => c.forEach((t) => t()), o = (t) => {
  e = { ...e, createClient: t }, n();
}, a = (t, l) => {
  e = { ...e, clientDict: { ...e.clientDict, [t]: l } }, n();
}, r = (t) => {
  const { [t]: l, ...i } = e.clientDict;
  e = { ...e, clientDict: i }, n();
}, D = {
  getSnapshot: s,
  subscribe: _,
  setCreateClient: o,
  addClient: a,
  removeClient: r
};
export {
  D as clientStore
};
